import React, { useState, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { SettingsIcon } from "src/assets/icons/settingsIcons";
import { Dropdown } from "./Dropdown.Settings";
import { useAuth } from "src/hooks/auth";
import {
  Key,
  DollarSign,
  Headphones,
  LogOut,
  UserPlus,
  Briefcase,
  Upload,
  CreditCard,
  BarChart2,
  UserCheck,
  List,
  Cat,
  ArrowUpCircle,
  CheckCircle,
  Tablet,
} from "lucide-react";

type OptionItem = {
  onSelect: () => void;
  selected: boolean;
  title: string;
  icon?: React.ReactNode;
};

export const SettingsBackOffice = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [manualTaxModalIsOpen, setManualTaxModalIsOpen] = useState(false);
  const href = window.location.href;

  const options: OptionItem[] = [
    {
      onSelect: () => navigate("/backoffice/config/persons"),
      selected: href.includes("/backoffice/config/persons"),
      title: "Atribuição de maquininha",
      icon: <CreditCard size={16} color="#10B981" />,
    },
    {
      onSelect: () => navigate("/backoffice/request-limits-users"),
      selected: href.includes("/backoffice/request-limits-users"),
      title: "Requisições de limites",
      icon: <CheckCircle   size={16} color="#6EE7B7" />,
    },
    {
      onSelect: () => navigate("/backoffice/config/tax"),
      selected: href.includes("/backoffice/config/tax"),
      title: "Plano da maquininha",
      icon: <Tablet   size={16} color="#34D399" />,
    },
    {
      onSelect: () => navigate("/backoffice/support"),
      selected: href.includes("/backoffice/support"),
      title: "Chat de suporte",
      icon: <Headphones size={16} color="#F59E0B" />,
    },
    {
      onSelect: () => navigate("/backoffice/config/operators/form"),
      selected: href.includes("/backoffice/config/operators/form"),
      title: "Operadores",
      icon: <UserPlus size={16} color="#3B82F6" />,
    },
    ...(user?.role === "MASTER"
      ? [
          {
            onSelect: () => setShow(!show),
            selected: false,
            title: "Cadastros",
            icon: <UserPlus size={16} color="#10B981" />,
          },
          ...(show
            ? [
                {
                  onSelect: () => navigate("/backoffice/signup-pf"),
                  selected: href.endsWith("/backoffice/signup-pf"),
                  title: "Conta PF",
                  icon: <UserCheck size={16} color="#3B82F6" />,
                },
                {
                  onSelect: () => navigate("/backoffice/signup-pj"),
                  selected: href.endsWith("/backoffice/signup-pj"),
                  title: "Contas PJ",
                  icon: <Briefcase size={16} color="#10B981" />,
                },
                {
                  onSelect: () => alert("Em construção"),
                  selected: false,
                  title: "Cadastro em massa",
                  icon: <Upload size={16} color="#F59E0B" />,
                },
              ]
            : []),
          {
            onSelect: () => navigate("/backoffice/get-transaction-delbank"),
            selected: href.includes("/backoffice/get-transaction-delbank"),
            title: "Get Transactions",
            icon: <BarChart2 size={16} color="#2563EB" />,
          },
          {
            onSelect: () => navigate("/backoffice/get-count-transactions"),
            selected: href.includes("/backoffice/get-count-transactions"),
            title: "Quantidade de transações",
            icon: <List size={16} color="#9333EA" />,
          },
          {
            onSelect: () => setManualTaxModalIsOpen(true),
            selected: false,
            title: "Taxa manual",
            icon: <DollarSign size={16} color="#D97706" />,
          },
        ]
      : []),
    {
      onSelect: () => navigate("/backoffice/logout"),
      selected: false,
      title: "Sair",
      icon: <LogOut size={16} color="#EF4444" />,
    },
  ];

  return (
    <div ref={ref} className="mr-1">
      <Dropdown
        title={
          <SettingsIcon className=" w-[35px] h-[25px] 1xl:w-[35px] 1xl:h-[35px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px]" />
        }
        min
        listWidth={250} // Ajusta o tamanho para melhor UX
        width={50}
        options={options}
      />
    </div>
  );
});
